export const RESET = 'BRAND_LIST_RESET'
export const SET_ITEMS = 'BRAND_LIST_SET_ITEMS'
export const SET_ERROR = 'BRAND_LIST_SET_ERROR'
export const SET_VIEW = 'BRAND_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'BRAND_LIST_TOGGLE_LOADING'
